import { render, staticRenderFns } from "./setting-create-duplicate-company.vue?vue&type=template&id=11c5a2a1&scoped=true"
import script from "./setting-create-duplicate-company.vue?vue&type=script&lang=js"
export * from "./setting-create-duplicate-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c5a2a1",
  null
  
)

export default component.exports